import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

interface Props {
  /** All timesheet calculation events, first-time calcs + redos together. */
  total: number | undefined
  /** Redos only — a strict subset of `total`. */
  recalculations: number | undefined
}

const fmt = (n: number | undefined): string =>
  n == null ? '-' : new Intl.NumberFormat().format(n)

/**
 * Renders the timesheet-calculation count. Recalculations used to have their
 * own column, which read as an additional charge even though they are already
 * inside the total; they now survive only as a hover hint on the total.
 */
const TimesheetCalcsCell: React.FC<Props> = ({ total, recalculations }) => {
  const { t } = useLocalize()
  const hint = recalculations
    ? `${t('billing.recalcsHint')}: ${fmt(recalculations)}`
    : undefined
  return <span title={hint}>{fmt(total)}</span>
}

export default TimesheetCalcsCell
